module.exports = __webpack_public_path__ + "img/caseFiled_btn.e8f879d6.svg";